/**
 * Situação da notícia
 */
export enum NewsStatus {
  SCHEDULED = 'SCHEDULED', // Programada
  PUBLISHED = 'PUBLISHED', // Publicada
  NOT_PUBLISHED = 'NOT_PUBLISHED', // Não publicada
  DRAFT = 'DRAFT', // Rascunho
  DELETED = 'DELETED', // Deletada
}

export type News = {
  uuid: string;
  business_unit_uuid: string;
  status: NewsStatus;
  title: string;
  content: string;
  source_url: string;
  image_url: string;
  created_at: string;
  publish_at: string;
  published_at: string;
  updated_at: string;
  deleted_at: string;
  attempt_count?: number;
  author?: string;
  author_username?: string;
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
};

export const translateNewStatus = (status: NewsStatus): string => {
  switch (status) {
    case NewsStatus.PUBLISHED:
      return 'Publicada';
    case NewsStatus.SCHEDULED:
      return 'Programada';
    case NewsStatus.NOT_PUBLISHED:
      return 'Não publicada';
    case NewsStatus.DRAFT:
      return 'Rascunho';
    case NewsStatus.DELETED:
      return 'Excluída';
    default:
      return status;
  }
};

export const colorByNewStatus = (status: NewsStatus): string => {
  switch (status) {
    case NewsStatus.PUBLISHED:
      return 'brand.500';
    case NewsStatus.SCHEDULED:
      return 'gray.500';
    case NewsStatus.NOT_PUBLISHED:
      return 'gray.500';
    case NewsStatus.DRAFT:
      return 'gray.500';
    case NewsStatus.DELETED:
      return 'gray.500';
    default:
      return 'gray.500';
  }
};
